import { ISeriesModelHomeGridCMSProps } from '@/lib/contentstack-sdk/types';
import { SeriesModelHomeGrid } from './tm-home-plan-detail-series-model-home-grid';
import { getModelHomes } from '@/lib/data/getStudioModelHomes';

export const SeriesModelHomeGridCS = async ({
  block,
}: {
  block: ISeriesModelHomeGridCMSProps;
}) => {
  const {
    plan_series_name,
    grid_heading,
    heading_element,
    heading_variant,
    top_spacing,
    bottom_spacing,
  } = block;

  const modelHomes = await getModelHomes();
  const seriesModelHomes = modelHomes.filter(
    (model) => model.Plan.Id === Number(plan_series_name.select),
  );

  if (!seriesModelHomes) return null;

  return (
    <SeriesModelHomeGrid
      modelHomes={seriesModelHomes}
      gridHeading={grid_heading}
      headingElement={heading_element?.select}
      headingVariant={heading_variant?.select}
      topSpacing={top_spacing.spacing_value}
      bottomSpacing={bottom_spacing.spacing_value}
    />
  );
};
